import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminLogin.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const AdminLogin = ({ setLoginStatus }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/login`, { email, password });
            const { token } = res.data;
            localStorage.setItem("token", token);
            localStorage.setItem("isAdmin", "true");
            setLoginStatus(true);
            window.location.href = "/admin/dashboard";
        } catch (err) {
            setError("Invalid credentials. Try again.");
        }
    };

    return (
        <div className="AdminLoginPageCSS">
        <div className="admin-login-container">
            <h2>Admin Login</h2>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleLogin}>
                <label>Email:</label>
                <input type="email" value={email} placeholder={"Enter Email"} onChange={(e) => setEmail(e.target.value)} required />
                <label>Password:</label>
                <div className="password-input-wrapper">
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        placeholder="Enter Password"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span
                        className="toggle-password"
                        onClick={() => setShowPassword((prev) => !prev)}
                    >
                {showPassword ? <FaEyeSlash size={22} color="#777" /> : <FaEye size={22} color="#777" />}
                </span>
                </div>
                <button type="submit">Login</button>
                <button type="button" onClick={() => navigate("/usher/login")}>
                    For Ushers
                </button>
            </form>
        </div>
        </div>
    );
};
export default AdminLogin;
